import script from "./TournamentCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentCheckout.vue?vue&type=script&setup=true&lang=js"

import "./TournamentCheckout.vue?vue&type=style&index=0&id=21312550&lang=css"

const __exports__ = script;

export default __exports__